// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aLWN","colMin":"styles_colMin__1aM8l"};